import React from 'react';



export default function BuyerMapEd() {

  return (
    <>
        <h1>THE AS-IS STRATEGY CANVAS</h1>
        <p>The As-Is Strategy Canvas (picture 1) is a visual analytic tool that shows the team’s opinion about key factors of competition and what kind of offerings consumers receive in the industry currently.</p>
        <img src={`${process.env.PUBLIC_URL}/images/1. As-Is-com.jpg`} style={{width: 600}}/>
        <h3>
          Key elements of the Strategy Canvas:
        </h3>
        <p>
          1. The key competition factors (horizontal axis) are the main factors that the industry competes on and invests in.
        </p>

        <p>
          2. The offering level (vertical axis) shows what buyers receive across all of the key competition factors.
        </p>

        <p>
          3. A value curve or strategic profile is the graphic depiction of a company’s relative performance across its industry’s key competition factors.
        </p>
        <p>
          The main aim of this tool is to visualize how the team sees the current situation in the industry. As a result, everyone from the team understands what kind of offerings buyers receive from the main industry players.
        </p>

        <h3>
          How to work with this instrument:
        </h3>

        <p>
          1. Name your product’s current industry or the target industry in case you consider a start-up.
        </p>
        <p>
          2. Name key competition factors from the customer’s perspective.
        </p>
        <p>
          3. Choose the main industry players whom you consider your main competitors.
        </p>
        <p>
          4. Evaluate offerings of the main industry participants using key competition factors.
        </p>
        <p>
          5. To build the As-Is Strategy Canvas place key competition factors horizontally, point the level of offerings across all key factors vertically and, finally, connect the dots.
        </p>

        <h3>
          Rules:
        </h3>

        <p>
          1. The key competition factors must be at least 5 and no more than 12 factors. In case you consider commercial companies, the price must be included.
        </p>
        <p>
          2. As key factors of competition, choose only those factors which valuable to consumers. Name factors from the consumer’s perspective, not using technical terms.
        </p>




    </>
  )
}
